module.exports = __webpack_public_path__ + "media/images/icons/Send message, Send, Share.1-ec9a26ab22c0c8aeebba3bceda53b370.svg";